import React, { useEffect } from 'react';
import { EffectPropsType } from '~/common/types';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';

export const FormikEffect = ({
  isSubmitting,
  errors,
  isValidating,
  successUrl,
  formikRef,
  submitCount,
  trialLength,
  setClosedBanner,
  emailStep,
}: EffectPropsType) => {
  const errorMap = () => {
    Object.keys(errors).map((err) => {
      const errorMessage = errors[err];
      formikRef.current?.setFieldTouched(err, true);
      gtagEnvelope('event', 'trial_page_error', {
        error_type: 'form_field_submit_error',
        error_field: err,
        validation_failure_reason: errorMessage,
      });
    });
  };

  useEffect(() => {
    if (isSubmitting && Object.keys(errors).length > 0 && isValidating) {
      if (emailStep) {
        gtagEnvelope('event', 'cta_click', {
          cta_name: 'Next step',
          cta_position: 'Trial Form',
        });
        setClosedBanner(true);
        errorMap();
      } else {
        gtagEnvelope('event', 'cta_submit_click', {
          cta_name: `Start My Free ${trialLength}-Day Trial`,
          cta_url: `${window.location.origin}${window.location.pathname}${successUrl}`,
          cta_position: 'Trial Form',
        });
        errorMap();
        setClosedBanner(true);
      }
    }
  }, [submitCount]);
  return <></>;
};
